import DOMPurify from 'isomorphic-dompurify'
import { marked } from 'marked'
import { useState } from 'react'

export const MarkdownEditor = ({
	value,
	onChange,
	fieldName,
	disabled = false,
	rows = 3,
}: {
	value: string
	onChange?: any
	fieldName: string
	disabled?: boolean
	rows?: number
}) => {
	const [activeTab, setActiveTab] = useState<'edit' | 'preview'>('edit')
	// Calculate height based on rows: 1.6em line-height * rows + padding
	const previewHeight = `calc(1.6em * ${rows} + 1.5rem)`

	return (
		<div className="w-full items-start self-stretch bg-white font-light leading-[160%]">
			{!disabled && (
				<div className="flex">
					<button
						type="button"
						onClick={() => setActiveTab('edit')}
						className={`px-3 py-1 text-xs font-semibold ${
							activeTab === 'edit'
								? 'border-b-2 border-blue-500 text-blue-500'
								: 'text-gray-500 hover:text-gray-700'
						}`}
					>
						編集
					</button>
					<button
						type="button"
						onClick={() => setActiveTab('preview')}
						className={`px-3 py-1 text-xs font-semibold ${
							activeTab === 'preview'
								? 'border-b-2 border-blue-500 text-blue-500'
								: 'text-gray-500 hover:text-gray-700'
						}`}
					>
						プレビュー
					</button>
				</div>
			)}
			<div className="overflow-hidden p-[1px]">
				{activeTab === 'edit' ? (
					<textarea
						name={fieldName}
						defaultValue={value}
						className={`flex h-full w-full resize-none items-start self-stretch rounded border px-4 py-3 text-sm font-light leading-[160%]`}
						onChange={onChange}
						disabled={disabled}
						rows={rows}
					></textarea>
				) : (
					<div
						className="overflow-auto rounded border px-4 py-3 text-left font-light leading-[160%]"
						style={{ height: previewHeight }}
					>
						<MarkdownPreview value={value} className="text-sm" />
					</div>
				)}
			</div>
		</div>
	)
}

export const MarkdownPreview = ({
	value,
	className,
}: {
	value: string
	className?: string
}) => {
	if (value == null || value === '') {
		return null
	}
	return (
		<div
			className={`prose max-w-none break-words ${className ?? ''}`}
			dangerouslySetInnerHTML={{
				//@ts-ignore
				__html: DOMPurify.sanitize(marked.parse(value, { breaks: true })),
			}}
		></div>
	)
}
